import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';
import './Skills.css';

const skillCategories = [
  {
    title: 'Languages',
    skills: ['JavaScript', 'Python', 'Java', 'HTML5', 'CSS3', 'SQL'],
  },
  {
    title: 'Frameworks',
    skills: ['React', 'Node.js', 'Express.js', 'Spring Boot', 'Flutter'],
  },
  {
    title: 'Databases',
    skills: ['MongoDB', 'Firebase', 'PostgreSQL', 'MySQL'],
  },
  {
    title: 'DevOps & Tools',
    skills: ['Docker', 'Git/GitHub', 'Postman', 'VS Code', 'Vercel', 'Figma'],
  },
  {
    title: 'Currently Learning',
    skills: ['TypeScript', 'Microservices', 'Next.js'],
    learning: true,
  },
];

function Skills() {
  const revealRef = useScrollReveal();

  return (
    <section className="skills reveal" id="skills" ref={revealRef}>
      <div className="container">
        <span className="section-label">{"// Skills & Tools"}</span>
        <h2 className="section-title">Technical Expertise</h2>

        <div className="skills-categories">
          {skillCategories.map((category) => (
            <div key={category.title} className="skill-category">
              <h3 className="category-title mono">{category.title}</h3>
              <div className="skill-tags">
                {category.skills.map((skill) => (
                  <span
                    key={skill}
                    className={`skill-tag${category.learning ? ' learning' : ''}`}
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
